var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1054 3.71486C26.8453 3.49446 26.5304 3.34865 26.194 3.29294C25.8577 3.23723 25.5126 3.27369 25.1953 3.39845L3.56248 11.8945C3.18304 12.0391 2.86164 12.3044 2.64777 12.6495C2.43391 12.9947 2.33943 13.4006 2.37888 13.8047C2.41408 14.2087 2.57929 14.5903 2.84973 14.8925C3.12017 15.1946 3.48127 15.4009 3.87888 15.4805L9.37497 16.5703V23.4375C9.37478 23.809 9.48495 24.1722 9.6915 24.481C9.89806 24.7898 10.1917 25.0303 10.5351 25.1719C10.7624 25.2634 11.005 25.3111 11.25 25.3125C11.4962 25.3134 11.7402 25.2651 11.9676 25.1705C12.195 25.076 12.4012 24.937 12.5742 24.7617L15.6211 21.7266L20.2265 25.7813C20.5665 26.0811 21.0037 26.2477 21.457 26.25C21.6564 26.2541 21.8548 26.2224 22.0429 26.1563C22.3522 26.0584 22.6305 25.8815 22.8505 25.6431C23.0704 25.4047 23.2242 25.113 23.2969 24.7969L27.7031 5.5547C27.7801 5.22267 27.7652 4.87592 27.6599 4.55175C27.5546 4.22758 27.3629 3.93824 27.1054 3.71486ZM21.4687 24.375L11.8125 15.8789L25.7226 5.83595L21.4687 24.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSent);
export default __webpack_public_path__ + "static/media/social-sent.2449137916e0ee410ecd6b5164800646.svg";
export { ForwardRef as ReactComponent };